/**
 * Remember a review-window preset across visits.
 * Bar intervals stay on the chart; these keys are calendar windows only.
 */
export function readStoredPeriod(storageKey, fallback, allowedIds) {
  try {
    const saved = localStorage.getItem(storageKey);
    if (saved && allowedIds.includes(saved)) return saved;
  } catch (_) {
    /* private mode */
  }
  return fallback;
}

export function writeStoredPeriod(storageKey, value, allowedIds) {
  if (!value || !allowedIds.includes(value)) return;
  try {
    localStorage.setItem(storageKey, value);
  } catch (_) {
    /* private mode */
  }
}
